import React from 'react';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import gql from 'graphql-tag';
import { useQuery, useMutation } from '@apollo/react-hooks';

import Block from 'components/common/block';
import { ReactComponent as TrashIcon } from 'assets/vectors/remove-16px.svg';
import { ReactComponent as AddIcon } from 'assets/vectors/add-green-16px.svg';
import { ReactComponent as InsuFlangIcon } from 'assets/vectors/insulationFlangeIcon.svg';

import InsulationFlangesModal from './insulationFlangesModal';

const ArchiveStsProjectEquipment = gql`
  mutation ArchiveStsProjectEquipment($input: ArchiveStsProjectEquipmentInput!) {
    archiveStsProjectEquipment(archiveStsProjectEquipmentData: $input) {
      success
    }
  }
`;

const GetInsulationFlanges = gql`
  query StsProjectEquipments ($sortBy: [String], $stsprojectId: ID){
    stsprojectEquipments(sortBy: $sortBy, stsprojectId: $stsprojectId) {
      edges {
        node {
          id
          insulationFlange {
            id
            plNumber
            serialNumber
            size
            type
            location
          }
        }
      }
    }
  }
`;

function InsulationFlanges({ projectId, onAdd, allowEdit }) {
  const [showInsulationFlangesModal, setShowInsulationFlangesModal] = React.useState(false);

  const {data, refetch} = useQuery(GetInsulationFlanges, {
    variables: {
      stsprojectId: projectId,
      sortBy: ['created desc']
    },
    onError(e) {
      console.log(e);
    }
  });

  const [executeArchiveStsProjectEquipment, { loading: archiveLoading }] = useMutation(ArchiveStsProjectEquipment, {
    onCompleted() {
      refetch();
    }
  });

  function addInsulationFlange() {
    setShowInsulationFlangesModal(true);
  }

  function removeInsulationFlange(equipmentId) {
    executeArchiveStsProjectEquipment({
      variables: {
        input: {
          stsprojectEquipmentId: equipmentId,
        }
      }
    })
  }

  const projectEquipments = data ? data.stsprojectEquipments.edges.map(r => r.node).filter(r => !!r.insulationFlange) : [];
  const addedInsulationFlanges = projectEquipments.map(r => r.insulationFlange.id);

  return (
    <StyledBlock title={<BlockTitle><InsuFlangIcon style={{ marginRight: '8px'}} /> Insulation flanges</BlockTitle>}>
      <TableContainer>
        <Table aria-label="simple table" style={{ whiteSpace: 'nowrap' }}>
          <TableHead>
            <TableRow>
              <TableCell>
                PL Nr.
              </TableCell>
              <TableCell>
                Serial Nr.
              </TableCell>
              <TableCell>
                Size
              </TableCell>
              <TableCell>
                Type
              </TableCell>
              <TableCell>
                Location
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
          {
              !projectEquipments.length
                ? <TableRow>
                    <TableCell>None added</TableCell>
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                  </TableRow>
                : (
                  projectEquipments.map(equipment => (
                    <TableRow key={equipment.id}>
                      <TableCell>
                        <Link href={`/dashboard/equipment/insulationFlanges/${equipment.insulationFlange.id}`} target="_blank">{equipment.insulationFlange.plNumber}</Link>
                      </TableCell>
                      <TableCell>
                        {equipment.insulationFlange.serialNumber}
                      </TableCell>
                      <TableCell>
                        {equipment.insulationFlange.size}
                      </TableCell>
                      <TableCell>
                        {equipment.insulationFlange.type}
                      </TableCell>
                      <TableCell>
                        {equipment.insulationFlange.location}
                      </TableCell>
                      <TableCell align="right">
                        {
                          allowEdit && (
                            <IconButton
                              onClick={() => removeInsulationFlange(equipment.id)}
                              aria-label="delete insulation flange"
                              className="deleteButton"
                              disabled={archiveLoading}
                            >
                              <TrashIcon />
                            </IconButton>
                          )
                        }
                      </TableCell>
                    </TableRow>
                  ))
                )
            }
          </TableBody>
        </Table>
      </TableContainer>
      {
        allowEdit && (
          <ButtonWrapper>
            <Button
              variant="outlined"
              color="primary"
              onClick={addInsulationFlange}
              endIcon={<AddIcon />}
            >
            Add insulation flange
            </Button>
          </ButtonWrapper>
        )
      }
      { showInsulationFlangesModal && <InsulationFlangesModal setShowInsulationFlangesModal={setShowInsulationFlangesModal} projectId={projectId} refetch={refetch} addedInsulationFlanges={addedInsulationFlanges} onAdd={onAdd} /> }
    </StyledBlock>
  );
}

const BlockTitle = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.textColor};
`;

const StyledBlock = styled(Block)`
  width: 1080px;
  max-width: 100%;
  margin-bottom: 16px;
`;

const Link = styled.a`
  color: ${props => props.theme.colors.primaryColor};
  text-decoration: none;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;

  @media (${props => props.theme.breakpoints.tablet}) {
    justify-content: flex-start;
  }
`;

export default InsulationFlanges;
